import * as React from 'react';
import { PlanningGrid } from '../planning/PlanningGrid';
import { useBacs } from '../../hooks/useBacs';
import { usePlanning } from '../../hooks/usePlanning';
import { useDepots } from '../../hooks/useDepots';
import { generateMonthRange } from '../shared/MonthUtils';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import styles from '../App.module.scss';

export const PlanningView: React.FC = () => {
  const { depots } = useDepots();
  const { bacs, loading: bacsLoading, error: bacsError, refresh: refreshBacs } = useBacs();
  const { entries, loading: planLoading, error: planError, refresh: refreshPlan } = usePlanning();

  const now = new Date();
  const months = React.useMemo(
    () => generateMonthRange(now.getFullYear(), 1, 14),
    [now.getFullYear()]
  );

  const handleDataChanged = (): void => {
    refreshBacs();
    refreshPlan();
  };

  if (bacsLoading || planLoading) {
    return (
      <div className={styles.loading}>
        <Spinner size={SpinnerSize.medium} label="Chargement du planning..." />
      </div>
    );
  }

  if (bacsError || planError) {
    return (
      <div className={styles.error}>
        {bacsError || planError}
      </div>
    );
  }

  return (
    <PlanningGrid
      bacs={bacs}
      entries={entries}
      months={months}
      depotNames={depots.map(d => d.Title)}
      onDataChanged={handleDataChanged}
    />
  );
};
